import { render, staticRenderFns } from "./SettingsBilling.vue?vue&type=template&id=45e0edcb&scoped=true&lang=pug&"
import script from "./SettingsBilling.vue?vue&type=script&lang=js&"
export * from "./SettingsBilling.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBilling.vue?vue&type=style&index=0&id=45e0edcb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e0edcb",
  null
  
)

export default component.exports